import { Link } from "react-router-dom";
import styles from "../../../Styles/Register.module.css";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function RegisterForm({ sign_in }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const [agentType, setAgentType] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
 

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/app/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            fullname: data.fullname,
            email: data.email,
            phone_no: data.phone_no,
            account_type: data.account_type,
            business_name: data.business_name,
            password: data.password,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Error ${response.status}: ${JSON.stringify(errorData)}`
        );
      }

      const responseData = await response.json();
      
      toast.success("Sign Up Successful, Welcome! ",{
        position:"top-right"
      })

      reset();
      
    } catch (error) {
      
      console.error("Fetch error:", error);
      toast.error(`${error.message} Sign In Failed, Please Try again!`,{
        position:"top-right"
      })
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <div>
        <input
          type="text"
          placeholder="Full name"
          {...register("fullname", { required: "Please type your full name" })}
        />
        {errors.fullname && (
          <p className={styles.error_msg}>{errors.fullname.message}**</p>
        )}
      </div>

      <div>
        <input
          type="email"
          placeholder="Enter your email"
          {...register("email", {
            required: "Please type your email",
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: "Please enter a valid email address",
            },
          })}
        />
        {errors.email && (
          <p className={styles.error_msg}>{errors.email.message}**</p>
        )}
      </div>

      {agentType === "DISTRIBUTOR" && (
        <div>
          <input
            type="text"
            placeholder="Business name"
            {...register("business_name", {
              required: "Please type your Business name",
            })}
          />
          {errors.business_name && (
            <p className={styles.error_msg}>{errors.business_name.message}**</p>
          )}
        </div>
      )}

      <div>
        <select
          {...register("account_type", {
            required: "Please select an agent type",
          })}
          onChange={(e) => setAgentType(e.target.value)}
        >
          <option value="" disabled selected >-- Select Agent Type --</option>
          <option value="SUPERADMIN">Superadmin</option>
          <option value="ADMIN">Admin</option>
          <option value="DISTRIBUTOR">Distributor</option>
        </select>

        {errors.account_type && (
          <p className={styles.error_msg}>{errors.account_type.message}**</p>
        )}
      </div>

      <div>
        <input
          type="text"
          placeholder="Phone Number"
          {...register("phone_no", {
            required: "Please type your phone number",
            pattern: {
              value: /^\+?\d{10,14}$/,
              message: "Please enter a valid phone number",
            },
          })}
        />
        {errors.phone_no && (
          <p className={styles.error_msg}>{errors.phone_no.message}**</p>
        )}
      </div>

      <div className={styles.password}>
        <div className={styles.password_input}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            {...register("password", {
              required: "Please enter your password",
              pattern: {
                value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                message:
                  "Password must be at least 8 characters long and include a letter and a number",
              },
            })}
          />
          <div className={styles.eye_icon} onClick={togglePasswordVisibility}>
            {showPassword ? (
              <AiOutlineEyeInvisible style={{ width: "25px" }} />
            ) : (
              <AiOutlineEye style={{ width: "25px" }} />
            )}
          </div>
        </div>
        <div className={styles.password.text}>
          {errors.password && (
            <p className={styles.error_msg}>{errors.password.message}**</p>
          )}
        </div>
      </div>

      <Link className={styles.sign_up} to="/">
        {sign_in}
      </Link>

      <button type="submit" disabled={loading}>
        {loading ? "Loading..." : "Register"}
      </button>
      
    </form>
  );
}
